module.exports = __webpack_public_path__ + "img/16_67.eb85414f.png";